import {parseReference} from '@apps-common/geocorn-sdk/api/util.js';

// Extract the hashid from a fully qualified ID
export const getHashFromId = id => {
  if (!id) {
    return '';
  }

  try {
    return id
      .split('/') // Split by slash
      .pop() // Take the last part
      .split('#')[0] // Remove version (anything after #)
      .split('-') // Split by hyphen
      .pop(); // Take the last part
  } catch (e) {
    // If any part of the chain fails, return the original id or empty string as fallback
    return '';
  }
};

export const getCollectionIDFromReference = ref => {
  if (!ref) {
    return '';
  }
  const parsedRef = parseReference(ref);
  return getHashFromId(parsedRef.collectionId);
};

// we can evaluate whether refs are equal by comparing their hashids
export const refEquals = (ref1, ref2) => {
  if (!ref1 || !ref2) {
    return false;
  }
  const parsedRef1 = parseReference(ref1);
  const parsedRef2 = parseReference(ref2);
  if (
    (parsedRef1.featureId && !parsedRef2.featureId) ||
    (!parsedRef1.featureId && parsedRef2.featureId)
  ) {
    return false;
  }

  return (
    getHashFromId(parsedRef1.featureId) === getHashFromId(parsedRef2.featureId)
  );
};
